export default () => ({
    favorites: [],
    notes: null
})
